import React from 'react';
import { FiActivity, FiRadio, FiBarChart } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiActivity />,
        title: 'Scan the markets',
        description: 'Oversee crypto markets with relevant indicators and sentiment tracking for highly targeted decision making.'
    },
    {
        icon: <FiRadio />,
        title: 'Monitor hedgefunds',
        description: 'Follow the big moves from crypto hedgefunds all over the world as they acquire and rebalance their portfolios.'
    },
    {
        icon: <FiBarChart />,
        title: 'Follow the curve',
        description: 'Track fast-moving digital assets and their traction within the community to stay ahead.'
    },
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;